import { render, staticRenderFns } from "./MetaMenu.vue?vue&type=template&id=3f7cec63&"
import script from "./MetaMenu.vue?vue&type=script&lang=ts&"
export * from "./MetaMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports